class EditSupportController {
    constructor($window, ProjectTesterServiceApi) {
        this.$onInit = () => {
            this.init();
        };
        this.init = () => {
            this.data = {
                users: []
            };
            this.state = { team: this.resolve.team };
            this.ProjectTesterService.projectTesters().then((response) => {
                let data = response.data;
                this.data.users = [];
                for (let index = 0; index < data.length; index++) {
                    const supportUser = data[index];
                    if (supportUser.TeamId === this.state.team.Id || supportUser.TeamId <= 0) {
                        this.data.users.push({ user: supportUser, isSelected: this.state.team.SupportUsers.filter(i => i.Id === supportUser.Id).length > 0 });
                    }
                }
                data;
            });
            return;
        };
        this.cancel = () => {
            this.dismiss();
        };
        this.ok = () => {
            let teamId = this.state.team.Id;
            const usersToAdd = [];
            const usersToRemove = [];
            // determine which users should be added or removed by comparing it with the original assignment
            for (let index = 0; index < this.data.users.length; index++) {
                const item = this.data.users[index];
                if (item.isSelected) {
                    if (this.state.team.SupportUsers.filter(i => i.Id === item.user.Id).length === 0) {
                        usersToAdd.push(item.user);
                    }
                }
                else {
                    if (this.state.team.SupportUsers.filter(i => i.Id === item.user.Id).length > 0) {
                        usersToRemove.push(item.user);
                    }
                }
            }
            const selectedUsers = this.data.users.filter(i => i.isSelected).map(i => i.user);
            if (usersToAdd.length > 0) {
                this.ProjectTesterService.addProjectTester(teamId, { Ids: usersToAdd.map(i => i.Id) }, false).then(() => {
                    if (usersToRemove.length > 0) {
                        this.ProjectTesterService.removeProjectTester(teamId, { Ids: usersToRemove.map(i => i.Id) }).then(() => {
                            this.close({ $value: selectedUsers });
                        });
                    }
                    else {
                        this.close({ $value: selectedUsers });
                    }
                });
            }
            else {
                if (usersToRemove.length > 0) {
                    this.ProjectTesterService.removeProjectTester(teamId, { Ids: usersToRemove.map(i => i.Id) }).then(() => {
                        this.close({ $value: selectedUsers });
                    });
                }
                else {
                    // no modification done by the user
                    this.dismiss();
                    return;
                }
            }
        };
        this.window = $window;
        this.ProjectTesterService = ProjectTesterServiceApi;
    }
}
angular.module('app').component('editSupportModal', {
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    },
    templateUrl: 'scripts/app/partials/TeamAdmin/edit-support.tpl.html',
    controllerAs: 'vm',
    controller: EditSupportController
});
